module.exports = __webpack_public_path__ + "media/site_templates/www.rangehood-installation.com.au/images/our_services_3-52858f685beb1efc86554800043fa067.jpg";